module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.static) ? _c(_vm.textarea ? 'textarea' : 'input', {
    ref: "input",
    tag: "input",
    class: ['form-control', _vm.inputClass],
    attrs: {
      "type": _vm.type,
      "value": _vm.value,
      "name": _vm.name,
      "id": _vm._id,
      "disabled": _vm.disabled,
      "rows": _vm.rows || _vm.rowsCount,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      },
      "change": function($event) {
        _vm.onChange($event.target.value)
      },
      "keyup": function($event) {
        _vm.onKeyUp($event)
      },
      "focus": function($event) {
        _vm.$emit('focus')
      },
      "blur": function($event) {
        _vm.$emit('blur')
      }
    }
  }) : _c('b-form-input-static', {
    attrs: {
      "id": _vm._id,
      "value": _vm.value,
      "formatter": _vm.formatter
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-299237a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/form-input.vue
// module id = 231
// module chunks = 0